<template>
  <div>
    <div>
      <router-link to="/grzx/courseAssess" style="text-decoration: none">
        <el-button type="primary" icon="el-icon-arrow-left" size="mini" plain
          >返回</el-button
        >
      </router-link>
    </div>
    <div class="lke-top">
      <div class="lke-title">
        {{ tbsurvey.title }}
      </div>
      <div class="lke-title-fot">
        {{ tbsurvey.description }}
      </div>
    </div>
    <div class="lke-top">
      <el-form
        label-position="left"
        size="mini"
        label-width="20px"
        v-for="(list, index) in tbsurvey.tbsurveydataIds"
        :key="index"
      >
        <el-form-item :label="index + 1 + '、'">
          <p style="font-size: 14px; letter-spacing: 1px; font-weight: 600">
            {{ list.tbsurveydataInfo.title }}
          </p>
        </el-form-item>
        <el-form-item v-if="list.tbsurveydataInfo.type === 'oneChoice'">
          <el-radio-group v-model="tbsurveydataAnswers[index].answer">
            <div
              style="margin-bottom: 10px"
              v-for="(tab, index3) in list.tbsurveydataInfo.options"
              :key="index3"
            >
              <el-radio :label="xuanziIndex[index3]"
                >{{ xuanziIndex[index3] }}、{{ tab }}</el-radio
              >
            </div>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-else>
          <el-input
            type="textarea"
            :autosize="{ minRows: 2 }"
            placeholder="请输入答案"
            v-model="tbsurveydataAnswers[index].answer"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div style="padding: 10px; text-align: center">
        <el-button type="primary" @click="submit">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { gettbsurveysubmitOne, submittbsurveysubmit } from "@/api/index";
export default {
  name: "",
  data() {
    return {
      id: "",
      tbsurvey: {},
      xuanziIndex: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
      ],
      tbsurveydataAnswers: [],
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.gettbsurveysubmitOne();
  },
  mounted() {},
  filters: {},
  watch: {},
  methods: {
    submit() {
      for (let index = 0; index < this.tbsurveydataAnswers.length; index++) {
        if (!this.tbsurveydataAnswers[index].answer) {
          this.$message({
            message: "请全部填写后提交",
            type: "warning",
          });
          return;
        }
      }
      let obj = {
        tbsurveyId: this.id,
        tbsurveydataAnswers: JSON.stringify(this.tbsurveydataAnswers),
      };
      submittbsurveysubmit(obj).then((response) => {
        this.$message({
          message: "提交成功，感谢您的作答",
          type: "success",
        });
        setTimeout(() => {
          this.$router.push({
            path: `/grzx/courseAssess`,
          });
        }, 1000);
      });
    },

    gettbsurveysubmitOne() {
      gettbsurveysubmitOne(this.id).then((response) => {
        let list = [];
        for (let index = 0; index < response.tbsurveydataIds.length; index++) {
          list.push({
            tbsurveydataId: response.tbsurveydataIds[index].tbsurveydataId,
            answer: "",
          });
        }
        this.tbsurveydataAnswers = list;
        this.tbsurvey = response;
      });
    },
  },
  components: {},
};
</script>

<style>
</style>

<style scoped>
.lke-top {
  padding: 20px;
  margin: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);
}
.lke-title {
  text-align: center;
  font-size: 20px;
  letter-spacing: 1px;
  font-weight: bold;
  padding-bottom: 10px;
}
.lke-title-fot {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/page/grzx/courseAssess/assess.vue